// import React, { useEffect, useState } from "react";
// import Main from "../Main";
// import { checkFinkedaStatus, fetchMyFinkedaOrders } from "../../api/finkedaApi";
// import { autoDateFormat } from "../../utils/autoDateFormate";
// import { formatAmount } from "../../utils/formatAmount";
// import { useNotify } from "../../context/NotifyContext";
// import { useTxnDocActions } from "../../hooks/useTxnDocActions";
// import WalletHistoryBar from "../../components/WalletHistoryBar";
// import {
//   ListingFilters,
//   ListingPagination,
//   SortableTh,
//   AppBreadcrumbs,
//   RowActions,
//   StatusBadge,
//   CopyText,
//   useListingState,
//   TXN_STATUS_OPTIONS,
//   CompactSelect,
// } from "../../components/listing";
// import { exportTable } from "../../utils/downloadExcel";

// const PURPOSE_OPTIONS = [
//   { value: "", label: "All purposes" },
//   { value: "TERMINAL_LOAD", label: "Terminal Load" },
//   { value: "PAYOUT", label: "PG + Payout" },
//   { value: "SETTLEMENT", label: "Settlement" },
// ];

// const PgPayoutHistory = () => {
//   const { notify } = useNotify();
//   const listing = useListingState({ sortBy: "date", sortDir: "desc" });
//   const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("finkeda");
//   const [purpose, setPurpose] = useState("PAYOUT");
//   const [rows, setRows] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [refreshing, setRefreshing] = useState("");

//   const load = async () => {
//     const res = await fetchMyFinkedaOrders({
//       ...listing.query,
//       purpose: purpose || undefined,
//     });
//     if (res.success) {
//       setRows(res.data?.items || []);
//       setTotalPages(res.data?.pagination?.totalPages || 1);
//       setTotal(res.data?.pagination?.total || 0);
//       setTotalAmount(Number(res.data?.totalAmount) || 0);
//     } else {
//       notify(res.message || "Failed to load orders", "error");
//     }
//   };

//   useEffect(() => {
//     load();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     listing.page,
//     listing.limit,
//     listing.startDate,
//     listing.endDate,
//     listing.debouncedSearch,
//     listing.sortBy,
//     listing.sortDir,
//     listing.status,
//     purpose,
//   ]);

//   const refresh = async (urn) => {
//     setRefreshing(urn);
//     const res = await checkFinkedaStatus(urn);
//     if (res.success) {
//       notify("Status updated", "success");
//       load();
//     } else {
//       notify(res.message || "Status check failed", "error");
//     }
//     setRefreshing("");
//   };

//   return (
//     <Main showRightPanel={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "MATM Module" },
//             { label: "PG + Payout Reports" },
//           ]}
//         />
//         <WalletHistoryBar title="PG + Payout / Finkeda orders" to="/add-money-ledger">
//           <div>
//             <h2 className="text-xs font-semibold m-0">PG + Payout / Finkeda orders</h2>
//             <p className="text-[12px] text-[var(--text-muted)] m-0 mt-1">
//               Status is confirmed from Finkeda Check Status. Sender account and PAN are masked.
//             </p>
//           </div>
//         </WalletHistoryBar>

//         <div className="ds-card text-sm mt-2">
//           <ListingFilters
//             onClear={() => {
//               listing.clearFilters();
//               setPurpose("");
//             }}
//             startDate={listing.startDate}
//             endDate={listing.endDate}
//             onStartDate={listing.setStartDate}
//             onEndDate={listing.setEndDate}
//             search={listing.search}
//             onSearch={listing.setSearch}
//             searchPlaceholder="Search"
//             status={listing.status}
//             onStatus={listing.setStatus}
//             statusOptions={TXN_STATUS_OPTIONS}
//             showApply
//             onApply={load}
//             applyLabel="Load Records"
//             actions={
//               <label className="ds-listing-field">
//                 <span className="ds-listing-field__label">Purpose</span>
//                 <CompactSelect
//                   className="ds-filter-status-select"
//                   value={purpose}
//                   onChange={(v) => {
//                     setPurpose(v);
//                     listing.setPage(1);
//                   }}
//                   options={PURPOSE_OPTIONS}
//                   placeholder="All purposes"
//                   ariaLabel="Purpose"
//                 />
//               </label>
//             }
//             onExport={() =>
//               exportTable(
//                 "finkeda-orders",
//                 [
//                   { label: "URN", key: "urn" },
//                   { label: "Purpose", key: "purpose" },
//                   { label: "Amount", key: "amount" },
//                   { label: "Charge", key: "charge" },
//                   { label: "Markup", key: "markup" },
//                   { label: "Payout", key: "payoutAmount" },
//                   { label: "Sender", value: (r) => r?.sender?.senderName ?? "" },
//                   { label: "Account", value: (r) => r?.sender?.senderAccount ?? "" },
//                   { label: "Txn ID", value: (r) => r?.transactionID ?? r?.txnId ?? "" },
//                   { label: "PG Status", value: (r) => r?.pgStatus ?? "" },
//                   { label: "Card", value: (r) => `${r?.cardType || ""} ${r?.cardNetwork || ""}`.trim() },
//                   { label: "Date", value: (r) => autoDateFormat(r?.createdAt) },
//                 ],
//                 rows,
//                 notify
//               )
//             }
//           />

//           <div className="ds-table-wrap ds-scroll mt-3">
//             <table className="ds-table ds-table-listing min-w-[980px]">
//               <thead>
//                 <tr>
//                   <th>URN</th>
//                   <th>Purpose</th>
//                   <SortableTh
//                     label="Amount"
//                     sortKey="amount"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Charge</th>
//                   <th>Markup</th>
//                   <th>Payout</th>
//                   <th>Sender</th>
//                   <th>PG / Card</th>
//                   <th>Txn ID</th>
//                   <SortableTh
//                     label="Status"
//                     sortKey="status"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <SortableTh
//                     label="Date"
//                     sortKey="date"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th className="ds-th-actions">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length === 0 ? (
//                   <tr>
//                     <td colSpan={12} className="text-center text-[var(--text-muted)]">
//                       NO DATA AVAILABLE IN TABLE
//                     </td>
//                   </tr>
//                 ) : (
//                   rows.map((row) => (
//                     <tr key={row.urn || row.txnId}>
//                       <td>
//                         <CopyText value={row.urn} />
//                       </td>
//                       <td>{row.purpose}</td>
//                       <td className="ds-td-amount">₹{formatAmount(row.amount)}</td>
//                       <td>₹{formatAmount(row.charge)}</td>
//                       <td>{row.markup}%</td>
//                       <td>₹{formatAmount(row.payoutAmount)}</td>
//                       <td>
//                         <div className="font-semibold">{row.sender?.senderName || "—"}</div>
//                         <div className="text-[11px] text-[var(--text-muted)]">
//                           {row.sender?.senderAccount || ""}
//                         </div>
//                       </td>
//                       <td>
//                         <div>{row.pgStatus || row.orderStats || "—"}</div>
//                         <div className="text-[11px] text-[var(--text-muted)]">
//                           {row.cardType || ""} {row.cardNetwork || ""} {row.cardBank || ""}
//                         </div>
//                       </td>
//                       <td>
//                         {row.transactionID || row.orderId ? (
//                           <CopyText value={row.transactionID || row.orderId} />
//                         ) : (
//                           "—"
//                         )}
//                       </td>
//                       <td>
//                         <StatusBadge status={row.status} />
//                       </td>
//                       <td>{autoDateFormat(row.createdAt)}</td>
//                       <td>
//                         <RowActions
//                           onView={() => viewTxn(row)}
//                           onPdf={() => pdfTxn(row)}
//                           onPrint={() => printTxn(row)}
//                           onHistory={
//                             refreshing === row.urn
//                               ? undefined
//                               : () => refresh(row.urn)
//                           }
//                         />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//               <tfoot>
//                 <tr className="ds-table-total">
//                   <td colSpan={2} className="ds-table-total__label">
//                     TOTAL Amount
//                   </td>
//                   <td className="ds-table-total__value">₹ {formatAmount(totalAmount)}</td>
//                   <td colSpan={9}></td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//           <ListingPagination
//             page={listing.page}
//             totalPages={totalPages}
//             limit={listing.limit}
//             onPageChange={listing.setPage}
//             onLimit={listing.setLimit}
//             total={total}
//           />
//         </div>
//       </div>
//     </Main>
//   );
// };

// export default PgPayoutHistory;
import React, { useEffect, useState } from "react";
import Main from "../Main";
import { checkFinkedaStatus, fetchMyFinkedaOrders } from "../../api/finkedaApi";
import { autoDateFormat } from "../../utils/autoDateFormate";
import { formatAmount } from "../../utils/formatAmount";
import { useNotify } from "../../context/NotifyContext";
import { useTxnDocActions } from "../../hooks/useTxnDocActions";
import WalletHistoryBar from "../../components/WalletHistoryBar";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  AppBreadcrumbs,
  RowActions,
  StatusBadge,
  CopyText,
  useListingState,
  TXN_STATUS_OPTIONS,
  CompactSelect,
} from "../../components/listing";
import { exportTable } from "../../utils/downloadExcel";

const PURPOSE_OPTIONS = [
  { value: "", label: "All purposes" },
  { value: "TERMINAL_LOAD", label: "Terminal Load" },
  { value: "PAYOUT", label: "PG + Payout" },
  { value: "SETTLEMENT", label: "Settlement" },
];

/*
 * Final charge = Finkeda charge + markup amount (combined).
 * User ko markup alag se nahi dikhega, sirf final charge.
 * If backend sends markupAmount use it, else amount * markup / 100.
 * NOTE: agar row.charge me pehle se markup included hai to
 *       yahan sirf `return round2(charge)` kar dena.
 */
const finalCharge = (r) => {
  const amount = Number(r?.amount) || 0;
  const charge = Number(r?.charge) || 0;
  const markupAmt =
    r?.markupAmount != null
      ? Number(r.markupAmount)
      : (amount * (Number(r?.markup) || 0)) / 100;
  return Math.round((charge + markupAmt + Number.EPSILON) * 100) / 100;
};

const PgPayoutHistory = () => {
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("finkeda");
  const [purpose, setPurpose] = useState("PAYOUT");
  const [providerVersion, setProviderVersion] = useState("");
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [refreshing, setRefreshing] = useState("");

  const load = async () => {
    const res = await fetchMyFinkedaOrders({
      ...listing.query,
      purpose: purpose || undefined,
      providerVersion: providerVersion || undefined,
    });
    if (res.success) {
      setRows(res.data?.items || []);
      setTotalPages(res.data?.pagination?.totalPages || 1);
      setTotal(res.data?.pagination?.total || 0);
      setTotalAmount(Number(res.data?.totalAmount) || 0);
    } else {
      notify(res.message || "Failed to load orders", "error");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listing.page,
    listing.limit,
    listing.startDate,
    listing.endDate,
    listing.debouncedSearch,
    listing.sortBy,
    listing.sortDir,
    listing.status,
    purpose,
  ]);

  const refresh = async (urn) => {
    setRefreshing(urn);
    const res = await checkFinkedaStatus(urn);
    if (res.success) {
      notify("Status updated", "success");
      load();
    } else {
      notify(res.message || "Status check failed", "error");
    }
    setRefreshing("");
  };

  return (
    <Main showRightPanel={false}>
      <div className="mt-4">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "PG + Payout Reports" },
          ]}
        />
        <WalletHistoryBar title="PG + Payout orders" to="/add-money-ledger">
          <div>
            <h2 className="text-xs font-semibold m-0">PG + Payout orders</h2>
            <p className="text-[12px] text-[var(--text-muted)] m-0 mt-1">
              Status is confirmed from PG Check Status. Sender account and PAN are masked.
            </p>
          </div>
        </WalletHistoryBar>

        <div className="ds-card text-sm mt-2">
          <ListingFilters
            onClear={() => {
              listing.clearFilters();
              setPurpose("");
            }}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search"
            status={listing.status}
            onStatus={listing.setStatus}
            statusOptions={TXN_STATUS_OPTIONS}
            showApply
            onApply={load}
            applyLabel="Load Records"
            actions={
              <label className="ds-listing-field">
                <span className="ds-listing-field__label">Purpose</span>
                <CompactSelect
                  className="ds-filter-status-select"
                  value={purpose}
                  onChange={(v) => {
                    setPurpose(v);
                    listing.setPage(1);
                  }}
                  options={PURPOSE_OPTIONS}
                  placeholder="All purposes"
                  ariaLabel="Purpose"
                />
                <span className="ds-listing-field__label mt-2">Version</span>
                <CompactSelect
                  className="ds-filter-status-select"
                  value={providerVersion}
                  onChange={(v) => {
                    setProviderVersion(v);
                    listing.setPage(1);
                  }}
                  options={[
                    { value: "", label: "All versions" },
                    { value: "v1", label: "Finkeda V1" },
                    { value: "v2", label: "Finkeda V2" },
                  ]}
                  placeholder="All versions"
                  ariaLabel="Version"
                />
              </label>
            }
            onExport={() =>
              exportTable(
                "finkeda-orders",
                [
                  { label: "URN", key: "urn" },
                  { label: "Purpose", key: "purpose" },
                  { label: "Amount", key: "amount" },
                  { label: "PG Charge", value: (r) => finalCharge(r) },
                  { label: "Payout Charge",key:"payoutCharge"},
                  { label: "Payout", key: "payoutAmount" },
                  { label: "Pg Type", key: "pgType" },
                  { label: "Sender", value: (r) => r?.sender?.senderName ?? "" },
                  { label: "Account", value: (r) => r?.sender?.senderAccount ?? "" },
                  { label: "Txn ID", value: (r) => r?.transactionID ?? r?.txnId ?? "" },
                  { label: "PG Status", value: (r) => r?.pgStatus ?? "" },
                  { label: "Card", value: (r) => `${r?.cardType || ""} ${r?.cardNetwork || ""}`.trim() },
                  { label: "Date", value: (r) => autoDateFormat(r?.createdAt) },
                ],
                rows,
                notify
              )
            }
          />

          <div className="ds-table-wrap ds-scroll mt-3">
            <table className="ds-table ds-table-listing min-w-[900px]">
              <thead>
                <tr>
                  <th>URN</th>
                  <th>Purpose</th>
                  <SortableTh
                    label="Amount"
                    sortKey="amount"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th>PG Charge</th>
                  <th>Payout Charge</th>
                  <th>Payout</th>
                  <th>Pg Type</th>
                  <th>Sender</th>
                  <th>PG / Card</th>
                  <th>Txn ID</th>
                  <SortableTh
                    label="Status"
                    sortKey="status"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <SortableTh
                    label="Date"
                    sortKey="date"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th className="ds-th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={11} className="text-center text-[var(--text-muted)]">
                      NO DATA AVAILABLE IN TABLE
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr key={row.urn || row.txnId}>
                      <td>
                        <CopyText value={row.urn} />
                      </td>
                      <td>{row.purpose}</td>
                      <td className="ds-td-amount">₹{formatAmount(row.amount)}</td>
                      <td>₹{formatAmount(finalCharge(row))}</td>
                      <td>₹{formatAmount(row.payoutCharge)}</td>
                      <td>₹{formatAmount(row.payoutAmount)}</td>
                      <td>{row.pgType}</td>
                      <td>
                        <div className="font-semibold">{row.sender?.senderName || "—"}</div>
                        <div className="text-[11px] text-[var(--text-muted)]">
                          {row.sender?.senderAccount || ""}
                        </div>
                      </td>
                      <td>
                        <div>{row.pgStatus || row.orderStats || "—"}</div>
                        <div className="text-[11px] text-[var(--text-muted)]">
                          {row.cardType || ""} {row.cardNetwork || ""} {row.cardBank || ""}
                        </div>
                      </td>
                      <td>
                        {row.transactionID || row.orderId ? (
                          <CopyText value={row.transactionID || row.orderId} />
                        ) : (
                          "—"
                        )}
                      </td>
                      <td>
                        <StatusBadge status={row.status} />
                      </td>
                      <td>{autoDateFormat(row.createdAt)}</td>
                      <td>
                        <RowActions
                          onView={() => viewTxn(row)}
                          onPdf={() => pdfTxn(row)}
                          onPrint={() => printTxn(row)}
                          onHistory={
                            refreshing === row.urn
                              ? undefined
                              : () => refresh(row.urn)
                          }
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr className="ds-table-total">
                  <td colSpan={2} className="ds-table-total__label">
                    TOTAL Amount
                  </td>
                  <td className="ds-table-total__value">₹ {formatAmount(totalAmount)}</td>
                  <td colSpan={8}></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <ListingPagination
            page={listing.page}
            totalPages={totalPages}
            limit={listing.limit}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
            total={total}
          />
        </div>
      </div>
    </Main>
  );
};

export default PgPayoutHistory;